import { useQuery } from "@tanstack/react-query";
import { getCancelReasons } from "../api/get-cancel-reasons";

export const useGetCancelReasons = (enabled = false) => {
  return useQuery({
    queryKey: ["cancelReasons"],
    queryFn: getCancelReasons,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
};
